const CANONICAL = process.env.REACT_APP_CANONICAL_HOST;
const STAY_KEY = "meridian-stay-on-host";

export function redirectToCanonical() {
  const { hostname, pathname, search, hash } = window.location;
  if (!CANONICAL || hostname === CANONICAL || hostname === `www.${CANONICAL}` || hostname === "localhost") return;
  const params = new URLSearchParams(search);
  if (params.get("stay") === "1") sessionStorage.setItem(STAY_KEY, "1");
  if (sessionStorage.getItem(STAY_KEY)) return;
  const controller = new AbortController();
  setTimeout(() => controller.abort(), 4000);
  fetch(`https://${CANONICAL}/api/health`, { signal: controller.signal, cache: "no-store" })
    .then((res) => res.json())
    .then((data) => {
      if (data?.status === "ok") window.location.replace(`https://${CANONICAL}${pathname}${search}${hash}`);
    })
    .catch(() => {});
}
